import { render } from "./ChangePassword.vue?vue&type=template&id=14da6a50"
import script from "./ChangePassword.vue?vue&type=script&lang=js"
export * from "./ChangePassword.vue?vue&type=script&lang=js"

import "./ChangePassword.vue?vue&type=style&index=0&id=14da6a50&lang=css"

import exportComponent from "/home/ubuntu/chatbot/chatbot_web/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__